import ii from "./iconix.webp";
import ii2 from "./iconix (2).webp";
import ii3 from "./iconix (1).webp";

const iiImages = [ii3, ii2, ii];

export default iiImages;
